module.exports = __webpack_public_path__ + "static/media/keyhole.d2d8ed46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/keyhole.svg
// module id = 242
// module chunks = 7